import { createContext } from "react";
import { OrganizationWithRole } from "@/services/organization";

export interface OrganizationContextType {
  currentOrganization: OrganizationWithRole | null;
  organizations: OrganizationWithRole[];
  loading: boolean;
  setCurrentOrganization: (org: OrganizationWithRole | null) => void;
  refreshOrganizations: () => Promise<unknown>;
}

export const OrganizationContext = createContext<OrganizationContextType | undefined>(undefined);
